import OrderChangeHistoryModal from './components/OrderChangeHistoryModal.css';

export default {
	OrderChangeHistoryModal
};
